import Model from '@models/Model'
import Country from '@models/Country'
import Office from '@models/Office'

class UserRole extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'name',
        'resource_type',
        'resource_id',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'created_at',
        'updated_at',
      ],
      relationships: {
        resource: { collection: false, polymorphic: { country: Country, 'office': Office } },
      },
    })
  }
}

export default UserRole
